import cs from "classnames";
import { observer } from "mobx-react-lite";
import type { HTMLAttributes } from "react";

const GroupTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cs("text-2xl text-ink font-semibold", className)} {...props} />
);

export default observer(GroupTitle);
